// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__301_V","content":"styles_content__VCrTd","row":"styles_row__3YeQE","footer":"styles_footer__2oAMy","phraseLength":"styles_phraseLength__29wfo"};